(function($) {  

  let $shortcodeSCF = $('.ShortCode.SearchCategoriesFind')
  if($shortcodeSCF.length) { 

    $shortcodeSCF = $shortcodeSCF.eq(0)

    const $selectorproducts = $shortcodeSCF.find('.Selector.Products')
    const $selectorindustries = $shortcodeSCF.find('.Selector.Industries')
    const $searchbutton =  $shortcodeSCF.find('.Search')

    $searchbutton
    .on(
      'click',
      function(e) {

        const $this = $(this)
        const coursesurl = $this.data('url')

        const searchquery = `${ coursesurl }?products=${ $selectorproducts.val() }&industries=${ $selectorindustries.val() }`

        location = location.origin + location.pathname + searchquery
      }
    )  
  }

})(jQuery)